// This is used to calculate the stats for the community hub
// including the pickup date, time, cutoff, delivery fee and more.
import NextPickupDay from "./NextPickupDay.js";
import moment from "moment";

export default function CalcHubStats(userInfo, currentStatus) {
  // This is the communityLocation details if one exists.  This is when the user
  // selects a community member's location to pickup instead of a distribution location.
  let communityLocation = "";
  // This is the distribution location's details.  This is used when a user selects
  // a community location and we need to know the details of the distribution location
  // this community location is partnered with.
  let distributionLocation = "";
  // The order cutoff date that is calculate from the distribution location next orderCutoff.
  let orderCutoffDate = "no date";
  // Provides the date of the pickup day for the user.
  let pickupDate = "no date";
  // The address of the pickup location.
  let address = "";
  // The order cutoff of the distribution location for ordering.
  let orderCutoff = "";
  // The pickup day for this location.
  let pickupDay = "";
  // The time to pickup the order from this location.
  let pickupTime = "";
  // The delivery fee charged to each user after being divided amongst them.
  let deliveryFee = 0;
  // The base delivery fee that is shared by all the community members.
  let baseDeliveryFee = 0;
  // Set the minimum delivery fee
  let minDeliveryFee = 0.0;
  // The max subsidy a user can claim at this location.
  let subsidyAmount = "";

  // If the user is picking up from a community hub then we have to set the base
  // delivery fee to what the location is actually supposed to be.
  if (userInfo.pickupLocation !== undefined) {
    // If the marketplace is for pickup at a community host.
    if (userInfo.pickupLocation.pickupLocation !== undefined) {
      // Set the CommunityHost to the pickup location.
      communityLocation = userInfo.pickupLocation;
      // The base delivery fee that is set by the distribution location.
      baseDeliveryFee = communityLocation.pickupLocation.baseDeliveryFee;
      minDeliveryFee = communityLocation.pickupLocation.minDeliveryFee;

      // If the communityHub has a special delivery fee set it.
      if (
        communityLocation.communityDeliveryFee ||
        communityLocation.communityDeliveryFee === 0
      ) {
        baseDeliveryFee = communityLocation.communityDeliveryFee;
      }
      // Set the distributionLocation to the CommunityHost's distribution location.
      distributionLocation = userInfo.pickupLocation.pickupLocation;
      // Provides the date of the order cutoff for the user.
      orderCutoffDate = moment(
        NextPickupDay(distributionLocation.orderCutoff),
        "MM-DD-YYYY",
      ).format("MMMM D Y");
      // Provides the date of the pickup day for the user.
      pickupDate = moment(
        NextPickupDay(distributionLocation.pickupDay),
        "MM-DD-YYYY",
      ).format("MMMM D Y");
      // Set the location's address
      address = userInfo.pickupLocation.address;
      // Set the location's orderCutoff
      orderCutoff = distributionLocation.orderCutoff;
      // Set the location's pickupDay
      pickupDay = communityLocation.pickupDay;
      // Set the location's pickup times
      pickupTime = communityLocation.availableTimes;
      // Set the location's subsidyAmount
      subsidyAmount = distributionLocation.subsidyAmount;
      // If the user has already ordered then the delivery fee is 0.
      if (!currentStatus[2]) {
        // Check to see if there any people ordering from this location.  If there
        // is no one yet then we don't want to divide by 0 so we just say it is the maximum
        // delivery fee amount.
        if (currentStatus[1] > 0 && !!userInfo.pickupLocation.pickupLocation) {
          let numberOfSplitting = currentStatus[1];
          // If the current user has not already ordered and they are placing a new
          // order then we want to add them to the total count.
          if (!currentStatus[2]) {
            numberOfSplitting += 1;
          }
          // Set the delivery fee to equal the base fee divided amongst all the users.
          deliveryFee = baseDeliveryFee / numberOfSplitting;
          if (minDeliveryFee > deliveryFee) {
            deliveryFee = minDeliveryFee;
          }
        }
        // If there are no other users then the delivery fee is the base fee.
        else {
          deliveryFee = baseDeliveryFee;
        }
      }
    }
    // If the user is picking up from the distribution location's main site (not a community hub).
    else {
      // Provides the date of the order cutoff for the user.
      orderCutoffDate = moment(
        NextPickupDay(userInfo.pickupLocation.orderCutoff),
        "MM-DD-YYYY",
      ).format("MMMM D Y");
      // Provides the date of the pickup day for the user.
      pickupDate = moment(
        NextPickupDay(userInfo.pickupLocation.pickupDay),
        "MM-DD-YYYY",
      ).format("MMMM D Y");
      // Set the location's address
      address = userInfo.pickupLocation.address;
      // Set the location's orderCutoff
      orderCutoff = userInfo.pickupLocation.orderCutoff;
      // Set the location's pickupDay
      pickupDay = userInfo.pickupLocation.pickupDay;
      // Set the location's pickup times
      pickupTime = userInfo.pickupLocation.pickupTime;
      // Set the location's subsidyAmount
      subsidyAmount = userInfo.pickupLocation.subsidyAmount;
    }
  }
  return [
    deliveryFee,
    baseDeliveryFee,
    minDeliveryFee,
    communityLocation,
    distributionLocation,
    orderCutoffDate,
    pickupDate,
    address,
    orderCutoff,
    pickupDay,
    pickupTime,
    subsidyAmount,
  ];
}
